// extracted by mini-css-extract-plugin
export default {"page_container":"PageInfo_page_container__XEqQl","content":"PageInfo_content__hLqU1"};